export default function setDisplayedUploads(idType) {
  if (
    idType === "運転免許証（運転経歴証明書）" ||
    idType === "住民基本台帳カード" ||
    idType === "在留カード" ||
    idType === "健康保険証" ||
    idType === "特別永住者証明書"
  ) {
    return true;
  } else {
    return false;
  }
}
